import SectionWrapper from '../components/SectionWrapper';
import ScrollReveal from '../components/ScrollReveal';
import ChartPieRevenue from '../charts/ChartPieRevenue';
import ChartBarCost from '../charts/ChartBarCost';
import { BUSINESS_MODEL } from '../data/mockData';

// 区块6：商业模式
export default function Section06Business() {
  return (
    <SectionWrapper
      id="business"
      title="商业模式"
      subtitle="本项目构建「SaaS订阅 + 能力认证 + 双师服务 + 内容分润」的多元收入结构，形成可持续商业闭环。"
    >
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* 中央：9宫格商业模式画布 */}
        <ScrollReveal className="lg:col-span-2">
          <div className="glass-card">
            <h3 className="text-2xl font-bold text-gold mb-6 text-center">商业模式画布</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {BUSINESS_MODEL.map((item, index) => (
                <div
                  key={index}
                  className="p-5 rounded-xl bg-white/5 border border-white/10 hover:border-gold/40 transition-all hover:-translate-y-1"
                >
                  <h4 className="text-lg font-bold text-cyan mb-2">{item.title}</h4>
                  <p className="text-sm text-slate-300 leading-relaxed">{item.content}</p>
                </div>
              ))}
            </div>
          </div>
        </ScrollReveal>

        {/* 右侧：收入结构饼图 */}
        <ScrollReveal delay={150}>
          <div className="glass-card min-h-[420px]">
            <ChartPieRevenue />
          </div>
        </ScrollReveal>
      </div>

      {/* 底部：成本结构柱状图 */}
      <ScrollReveal delay={200}>
        <div className="glass-card mt-8 min-h-[400px]">
          <ChartBarCost />
        </div>
      </ScrollReveal>
    </SectionWrapper>
  );
}
